import React from "react";
import Img, { ImgData } from "../Img";

interface Props {
  type: string;
  title: string;
  description: string;
  image?: ImgData;
  className?: string;
}

const ServiceDetailHeader = ({ type, title, description, image }: Props) => (
  <header className="relative z-10 w-full bg-brand-light">
    <div className="container relative pt-80 md:pt-0">
      <div className="relative z-20 flex w-full items-center py-12 md:min-h-100 md:w-2/3">
        <div className="space-y-6">
          <p className="font-title text-base text-brand">{type}</p>
          <h1 className="h1">{title}</h1>
          <div
            className="text-2xl"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
      <div className="absolute inset-x-0 top-0 z-10 w-full md:hidden">
        <Img className="mask-y h-80 w-full object-cover" image={image} />
      </div>
      <div className="absolute inset-y-0 right-0 z-10 hidden w-2/3 md:block 2xl:mr-12">
        <Img className="mask-x h-full w-full object-cover" image={image} />
      </div>
    </div>
  </header>
);

export default ServiceDetailHeader;
